import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";
const PUBLIC_BASE = "/api/v1/automap";

function authHeaders() {
  return { credentials: "include", headers: { "Content-Type": "application/json" } };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") search.set(k, v);
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchPartnersDashboard() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/dashboard`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar aliados.");
  return res.json();
}

export async function fetchPartners(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar aliados.");
  return res.json();
}

export async function fetchPartner(partnerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/${encodeURIComponent(partnerId)}`, authHeaders());
  if (!res.ok) throw new Error("Aliado no encontrado.");
  return res.json();
}

export async function createPartner(body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "No se pudo crear aliado.");
  }
  return res.json();
}

export async function updatePartner(partnerId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/${encodeURIComponent(partnerId)}`, {
    method: "PATCH",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("No se pudo actualizar aliado.");
  return res.json();
}

export async function archivePartner(partnerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/${encodeURIComponent(partnerId)}/archive`, {
    method: "POST",
    ...authHeaders(),
  });
  if (!res.ok) throw new Error("No se pudo archivar aliado.");
  return res.json();
}

export async function fetchPartnerLeads(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/leads${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar leads de aliados.");
  return res.json();
}

export async function fetchPartnerLead(leadId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/leads/${encodeURIComponent(leadId)}`, authHeaders());
  if (!res.ok) throw new Error("Lead no encontrado.");
  return res.json();
}

export async function updatePartnerLeadStatus(leadId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/leads/${encodeURIComponent(leadId)}/status`, {
    method: "PATCH",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("No se pudo actualizar estado.");
  return res.json();
}

export async function routePartnerLead(leadId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/leads/${encodeURIComponent(leadId)}/route`, {
    method: "POST",
    ...authHeaders(),
  });
  if (!res.ok) throw new Error("No se pudo enrutar lead.");
  return res.json();
}

export async function deliverPartnerLead(leadId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/leads/${encodeURIComponent(leadId)}/deliver`, {
    method: "POST",
    ...authHeaders(),
  });
  if (!res.ok) throw new Error("No se pudo marcar entrega.");
  return res.json();
}

export async function addPartnerLeadNote(leadId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/leads/${encodeURIComponent(leadId)}/notes`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("No se pudo agregar nota.");
  return res.json();
}

export async function fetchPartnerPerformance(partnerId, dateRange = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/partners/${encodeURIComponent(partnerId)}/performance${qs({ dateRange })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar performance.");
  return res.json();
}

export async function fetchPartnerAnalytics(dateRange = "last_30_days") {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/analytics${qs({ dateRange })}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar analytics.");
  return res.json();
}

export async function fetchPartnerCategories() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/categories`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar categorías.");
  return res.json();
}

export async function fetchPartnerRouting() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/routing`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar routing.");
  return res.json();
}

export async function fetchPartnerDisclosures() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/partners/disclosures`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar divulgaciones.");
  return res.json();
}

export async function submitPartnerLead(body) {
  const res = await fetch(`${API_BASE_URL}${PUBLIC_BASE}/partners/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "No se pudo enviar solicitud.");
  }
  return res.json();
}

export async function fetchPublicPartnerDisclosure(category, params = {}) {
  const res = await fetch(`${API_BASE_URL}${PUBLIC_BASE}/partners/disclosure/${encodeURIComponent(category)}${qs(params)}`);
  if (!res.ok) throw new Error("No se pudo cargar divulgación.");
  return res.json();
}

export async function trackPartnershipEvent(eventType, metadata = {}) {
  try {
    await fetch(`${API_BASE_URL}${PUBLIC_BASE}/partners/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventType, metadata }),
    });
  } catch {
    /* non-blocking */
  }
}

export async function fetchDealerPartnerInterest(dealerId, listingId) {
  const res = await fetch(
    `${API_BASE_URL}/api/v1/automap/dealer-portal/${encodeURIComponent(dealerId)}/partner-interest${qs({ listingId })}`,
    authHeaders()
  );
  if (!res.ok) return { interests: [] };
  return res.json();
}

export async function fetchDealerLeadPartnerBadges(dealerId, listingId) {
  const res = await fetch(
    `${API_BASE_URL}/api/v1/automap/dealer-portal/${encodeURIComponent(dealerId)}/leads/partner-interest${qs({ listingId })}`,
    authHeaders()
  );
  if (!res.ok) return { badges: [] };
  return res.json();
}
